import React from "react";
import "./AssessmentProgressBar.css";

const AssessmentProgressBar = ({
  topics,
  topicToLoad,
  lessondetails,
  completionRecord,
  allCompletionRecords,
  maxAttemptLimitReached,
  maxAttemptsAssessment,
  maxAttemptsAssessmentMessage,
}) => {
  const totalQuestions = topics?.length ?? 0;
  const currentIndex = topics
    ? Math.max(topics.findIndex((t) => t.topic_id === topicToLoad?.topic_id) + 1, 1)
    : 1;

  const isComplete = lessondetails?.lessonComplete === "true";
  const assessmentResult = completionRecord?.assessmentResult ?? null;
  const passed = assessmentResult === "Pass";
  const showResult = isComplete && assessmentResult !== null;

  const answeredCount = topics ? topics.filter((t) => t.topicviewed === "true" || t.topicviewed === true).length : 0;
  const fillPct = Math.round((answeredCount / Math.max(totalQuestions, 1)) * 100);
  const fillColor = showResult ? (passed ? "#22c55e" : "#ef4444") : "#3b82f6";

  // Attempt history
  const attempts = allCompletionRecords ?? [];
  const attemptsDone = attempts.length;
  const maxAttempts = parseInt(maxAttemptsAssessment) || 5;
  const attemptsLeft = Math.max(maxAttempts - attemptsDone, 0);

  return (
    <div>
      {/* Main progress bar */}
      {!showResult && (
        <div className="apb-wrapper">
          <div className="apb-counter-box">
            <span className="apb-counter-label">QUESTION</span>
            <div className="apb-counter-numbers">
              <span className="apb-counter-current">{currentIndex}</span>
              <span className="apb-counter-of">of&nbsp;{totalQuestions}</span>
            </div>
          </div>
          <div className="apb-divider-v" />
          <div className="apb-track-area">
            <div className="apb-track-bg">
              <div className="apb-track-fill" style={{ width: `${fillPct}%`, background: fillColor }} />
            </div>
            <span className="apb-track-label">{fillPct}% complete</span>
          </div>
        </div>
      )}

      {/* Previous Attempts History */}
      {attempts.length > 0 && showResult && (
        <div className="apb-history-wrapper">
          <div className="apb-history-header">
            <div>
              <span className="apb-history-title">Previous Attempts</span>
              <div className="apb-history-row">
                {attempts.map((record, index) => {
                  const recPassed = record.assessmentResult === "Pass";
                  const recScore = record.assessmentScore ?? "–";
                  const recDate = record.addedEpoch
                    ? new Date(parseInt(record.addedEpoch)).toLocaleDateString("en-US", {
                      month: "short", day: "numeric", year: "numeric",
                    })
                    : "";
                  return (
                    <div
                      key={record.logid || index}
                      className="apb-history-card"
                      style={{ borderLeft: `3px solid ${recPassed ? "#22c55e" : "#ef4444"}` }}
                    >
                      <div className="apb-history-card-top">
                        <span className="apb-history-attempt-num">Attempt {attempts.length - index}</span>
                        <span
                          className="apb-history-badge"
                          style={{
                            background: recPassed ? "#dcfce7" : "#fee2e2",
                            color: recPassed ? "#15803d" : "#b91c1c",
                          }}
                        >
                          {recPassed ? "Pass" : "Fail"}
                        </span>
                      </div>
                      <div className="apb-history-card-bottom">
                        <span
                          className="apb-history-score"
                          style={{ color: recPassed ? "#16a34a" : "#dc2626" }}
                        >
                          {recScore}%
                        </span>
                        {recDate && <span className="apb-history-date">{recDate}</span>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="apb-attempts-box">
              <span className="apb-attempts-label">ATTEMPTS</span>
              <div className="apb-attempts-numbers">
                <span className="apb-attempts-done">{attemptsDone}</span>
                <span className="apb-attempts-of">of&nbsp;{maxAttempts}</span>
              </div>
              <span
                className="apb-attempts-remaining"
                style={{ color: attemptsLeft === 0 ? "#b91c1c" : "#16a34a" }}
              >
                {attemptsLeft === 0 ? "No retakes left" : `${attemptsLeft} retake${attemptsLeft !== 1 ? "s" : ""} left`}
              </span>
              {maxAttemptLimitReached && maxAttemptsAssessmentMessage && (
                <span className="apb-max-msg">{maxAttemptsAssessmentMessage}</span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssessmentProgressBar;